module.exports = __webpack_public_path__ + "img/everpay-small.818c6617.svg";